<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import InfoPreview from 'src/components/TemperatureScheme/TempSchemeDrawSections/InfoPreview.svelte';

	export let id: string;
	export let extTempSensorValue: any;

	// Accept unused props forwarded from parent without Svelte warnings
	export let units;
	export let thermostatDefTemp;
	export let type;
	export let actuators;
	export let deviceSensorId;
	export let deviceSensor;
	export let deviceSensorIsOnline;
	export let extTempSensor;
</script>

<SidepanelContent>
	<InfoPreview {id} value={extTempSensorValue} />
</SidepanelContent>
